import { useEffect, useState } from "react";

export default function InstallPopup() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [dontShow, setDontShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("hideInstallPopup") === "true") return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    closePopup();
  };

  const closePopup = () => {
    if (dontShow) {
      localStorage.setItem("hideInstallPopup", "true");
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <div style={overlayStyle}>
        <div style={popupStyle}>
          <h2 style={{ marginBottom: 8 }}>Install App 🚀</h2>
          <p style={{ color: "#555", fontSize: 14 }}>
            Get faster access and a full-screen experience.
          </p>

          <div style={{ marginTop: 20 }}>
            <button style={installBtn} onClick={handleInstall}>
              Install Now
            </button>
            <button style={closeBtn} onClick={closePopup}>
              Maybe Later
            </button>
          </div>

          <label style={checkboxStyle}>
            <input
              type="checkbox"
              checked={dontShow}
              onChange={(e) => setDontShow(e.target.checked)}
            />
            Don’t show me again
          </label>
        </div>
      </div>
    </>
  );
}
const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};

const popupStyle = {
  width: 320,
  background: "#fff",
  borderRadius: 16,
  padding: 20,
  textAlign: "center",
  boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
  animation: "scaleIn 0.3s ease",
};

const installBtn = {
  width: "100%",
  padding: "12px",
  borderRadius: 10,
  border: "none",
  background: "#2563eb",
  color: "#fff",
  fontSize: 16,
  cursor: "pointer",
};

const closeBtn = {
  width: "100%",
  padding: "10px",
  borderRadius: 10,
  border: "none",
  background: "#eee",
  marginTop: 10,
  cursor: "pointer",
};

const checkboxStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8,
  fontSize: 13,
  marginTop: 14,
  color: "#444",
};
